!(function (modObj) {
    var __symbolPrefix = "3r/login-api/login/"
    modObj.emailTypeLogins = ['email', 'password']
    modObj.emailTypeLogins._depends = { symbol : __symbolPrefix + "emailTypeLogins" }

    modObj.verifyPassword = async function (_, Device, passRegistration, delay, emailTypeLogins, schemeSettings, data, referrer, registerType) {
        console.log("SignIn");
        var isPaused = Device.paused
        var validate = ((schemeSettings.globals || {}).requiredDetails || "") == "None" ? true : undefined
        await Device.canUpdateData()
        
        let results = await Device.api('registerDev', {
            mode: 'signin',
            duid: Device.deviceId,
            uid: Device.thrid,
            type: emailTypeLogins.indexOf(registerType) >= 0 ? 'email' : registerType,
            schemeId: Device.schemeId,
            validate : validate,
            password: data.password,
            app: Device.schemeId,
            email: data.email,
            externalId : data.externalId
        }, 'post')

        if (results.requestStatus.status !== 'SUCCESS') {
            throw new Error(results.requestStatus.failureMessage)
        }
        
        if (Device.thrid != results.results.uid) {
            Device.updateThrid(results.results.uid)
            
            if (!isPaused) {
                await delay(500)
            }
        }
        
        await Device.getInfo()
        
        if (validate) {
            Device.variables = {
                enteredDetails : true
            }
            
            await Device.canUpdateData()
        }
        
        if (_.get(results,"results.response")) {
            return Device.processUnlockResults(results.results)
        }
        
        if (isPaused && validate) {
            Device.paused = false
        }

        return await passRegistration()
    }
    modObj.verifyPassword._depends = {
        symbol : __symbolPrefix + "verifyPassword",
        modules : [
            "_",
            "3r/Device",
            "3r/passRegistration",
            "3r/delay",
            __symbolPrefix + "emailTypeLogins",
            "3r/schemeSettings/webapp"
        ]
    }

    modObj.createPassword = async function (_, Device, passRegistration, delay, emailTypeLogins, schemeSettings, data, referrer, registerType) {
        console.log("Signup")
        var validate = ((schemeSettings.globals || {}).requiredDetails || "") == "None" ? true : undefined
        
        await Device.canUpdateData()
        
        let results = await Device.api('registerDev', {
            mode: 'signup',
            duid: Device.deviceId,
            uid: Device.thrid,
            type: emailTypeLogins.indexOf(registerType) >= 0 ? 'email' : registerType,
            validate: validate,
            schemeId: Device.schemeId,
            password: data.password,
            validate : validate,
            app: Device.schemeId,
            email: data.email,
            externalId: data.externalId
        }, 'post')

        if (results.requestStatus.status !== 'SUCCESS') {
            throw new Error(results.requestStatus.failureMessage)
        }

        let isPaused = Device.paused
        
        if (Device.thrid != results.results.uid) {
            Device.updateThrid(results.results.uid)
            if (!isPaused) {
                await delay(500)
            }
        }
        
        await Device.getInfo()
        
        if (validate) {
            Device.variables = {
                enteredDetails : true
            }
            
            await Device.canUpdateData()
        }
        
        if (_.get(results,"results.response")) {
            return Device.processUnlockResults(results.results)
        }
        
        if (validate) {
            Device.unlock("WEB.LoggedInFirstTime")
        }
        
        if (isPaused && validate) {
            Device.paused = false
        }

        return await passRegistration()
    }
    modObj.createPassword._depends = {
        symbol : __symbolPrefix + "createPassword",
        modules : [
            "_",
            "3r/Device",
            "3r/passRegistration",
            "3r/delay",
            __symbolPrefix + "emailTypeLogins",
            "3r/schemeSettings/webapp"
        ]
    }

    modObj.registerDetails = function registerDetails(_, crypto, Buffer, Device, makeLookup, passRegistration, unlockProfileQuestions, schemeSettings, delay, data, answers, privateAnswers) {
        /* Scheme data variables: registrationQueryParameters, registrationLookups, registrationServices */
        var isPaused = Device.paused
        
        return Device.canUpdateData().then(function() {
            //GVA-8 - Password Encryption/Decryption & Storage - Ensures that password question specified in config with valid encryption key are not stored in clear
            //in the user data. Decryption side can be tested with the external-package stored inside the "test-password-decryption-package" repository.
            //Test package will create a Lambda function and its designated web service to be passed over the user data containing the encrypted password
            let pwdQuestions = ((schemeSettings || {}).profileQuestions || []).filter(q => q.type==='password' && privateAnswers[q.question])
            if(pwdQuestions && pwdQuestions.length > 0){
                for(let i = 0; i < pwdQuestions.length; i++){
                    let question = pwdQuestions[i]
                    
                    if(question.encryptionKey && question.encryptionKey !== ''){
                        if(!crypto || !Buffer){
                            throw new Error("Crypto / Buffer required ")
                        }
                        
                        var toEncrypt = privateAnswers[question.question]
                    
                        toEncrypt = Buffer.from(toEncrypt)
                        var encrypted = crypto.publicEncrypt({
                            key: question.encryptionKey,
                            padding: 1 //constants.RSA_PKCS1_PADDING
                        }, toEncrypt)
                        encrypted = encrypted.toJSON()
                        
                        _.set(Device.variables, "public.profile." + question.question + "_encrypted", encrypted)
    
                        delete privateAnswers[question.question]
                    } else {
                        console.warn(question.question + ": Question doesn't have any encryption key configured, storing in clear")
                        _.set(Device.variables, "public.profile." + question.question, privateAnswers[question.question])
                        
                        delete privateAnswers[question.question]
                    }
                }
                
                Device.updateVariables()
            }
            
            return Device.canUpdateData()
        }).then(function () {
            return makeLookup("registration")({
                mode: 'regGM',
                duid: Device.deviceId,
                uid: Device.thrid,
                validate: true,
                app: Device.schemeId,
                schemeId: Device.schemeId,
                email: data.email,
                externalId: data.externalId,
                name: data.forename + " " + data.surname,
                firstname: data.forename,
                lastname: data.surname,
                mobile: data.phone,
                brandCode: Device.schemeId,
                loginIdType: data.loginIdType
            })
        }).then(function (regData) {
            return Device.api('registerDev', regData, 'post')
        }).then(function (results) {
            if (results.results && results.results.uid && results.results.uid != Device.thrid) {
                Device.updateThrid(results.results.uid)
                if (!isPaused) {
                    return delay(500)
                }
            }
        }).then(function (results) {
            return Device.getInfo().then(function () {
                return results
            })
        }).then(function (results) {
            Device.variables = {enteredDetails: true}
            return Device.canUpdateData().then(function () { return results })
        }).then(function (results) {
            if (_.get(results,"results.response")) {
                return Device.processUnlockResults(results.results)
            }
        }).then(function () {
            unlockProfileQuestions(answers)
            return Device.unlock("WEB.LoggedInFirstTime")
        }).then(function () {
            if (isPaused) {
                Device.paused = false
            }
            return passRegistration()
        })
    }
    modObj.registerDetails._depends = {
        symbol : __symbolPrefix + "registerDetails",
        modules : [
            "_",
            {
                symbol : "crypto",
                nullIfMissing : true
            },
            {
                symbol : "Buffer",
                nullIfMissing : true
            },
            "3r/Device",
            "3r/login-api/lookup/makeLookup",
            "3r/passRegistration",
            "3r/login-api/helpers/unlockProfileQuestions",
            "3r/schemeSettings/webapp",
            "3r/delay"
        ]
    }

    modObj.register = async function register(_, Device, makeLookup, delay, validDetails, passRegistration, schemeSettings, window, data, referrer, requirePassword, hasEnteredPassword) {
        var unlocks = []
        await Device.canUpdateData()
        
        if (_.get(Device,"info.user.ATTRIBUTES.validated", false) && validDetails(hasEnteredPassword) && !Device.info.user.mustLogin) {
            return unlocks
        }

        let regData = {
            mode: 'regGM',
            duid: Device.deviceId,
            uid: Device.thrid,
            validate: requirePassword ? undefined : true,
            referrer: referrer,
            schemeId: Device.schemeId,
            mobile: data.phone,
            app: Device.schemeId,
            externalId: data.externalId,
            email: data.email
        }

        regData = await makeLookup("registration")(regData)
        
        let results = await Device.api('registerDev', regData, 'post')

        let isPaused = Device.paused
        
        if (Device.thrid != results.results.uid) {
            Device.updateThrid(results.results.uid, true)
            
            if (!isPaused) {
                await delay(500)
            }
        }

        let info = await Device.getInfo()
        console.log("GetInfo:GotInfo");

        if (_.get(results,"results.response")) {
            Device.processUnlockResults(results.results)
        }
        
        await Device.unlock("WEB.Registered")
        await Device.canUpdateData()

        var validate = ((schemeSettings.globals || {}).requiredDetails || "") == "None" ? true : undefined
        if (validate) {
            Device.variables = {
                enteredDetails : true
            }
            
            await Device.canUpdateData()
        }

        if (isPaused && validate) {
            Device.paused = false
        }

        await passRegistration()
        
        if(window) {
            let userAgent = _.get(window, "navigator.userAgent", "").toLowerCase()
            unlocks.push(Device.unlock("field.registration.userAgent", userAgent))
            unlocks.push(Device.unlock("WEB.UserAgent", userAgent))
        }
        
        unlocks.push(Device.unlock("WEB.LoggedIn"))

        let valid = validDetails(hasEnteredPassword)
        
        if (Device.info.user.ATTRIBUTES.validated && valid) {
            return unlocks
        } else {
            return false
        }

    }

    modObj.register._depends = {
        symbol : __symbolPrefix + "register",
        modules : [
            "_",
            "3r/Device",
            "3r/login-api/lookup/makeLookup",
            "3r/delay",
            "3r/login-api/helpers/validDetails",
            "3r/passRegistration",
            "3r/schemeSettings/webapp",
            {
                symbol : "window",
                nullIfMissing : true
            }
        ]
    }

    modObj.isEmailLogin = function (emailTypeLogins, schemeSettings) {
        return emailTypeLogins.indexOf(schemeSettings.globals.registrationType) >= 0
    }
    modObj.isEmailLogin._depends = {
        symbol : __symbolPrefix + "isEmailLogin",
        modules : [
            __symbolPrefix + "emailTypeLogins",
            "3r/schemeSettings/webapp"
        ]
    }

    modObj.isPhoneLogin = function (schemeSettings) {
        return schemeSettings.globals.registrationType == "phone" 
    }
    modObj.isPhoneLogin._depends = {
        symbol : __symbolPrefix + "isPhoneLogin",
        modules : [
            "3r/schemeSettings/webapp"
        ]
    }

    modObj.isExternalIdLogin = function (schemeSettings) {
        return schemeSettings.globals.registrationType == "externalId" 
    }
    modObj.isExternalIdLogin._depends = {
        symbol : __symbolPrefix + "isExternalIdLogin",
        modules : [
            "3r/schemeSettings/webapp"
        ]
    }

    modObj.getLookupRedirectUrl = function (schemeSettings, data) {
        let redirectUrl

        if (schemeSettings.globals.loginLookupRedirect) {
            let names = []
            if (typeof schemeSettings.globals.loginLookupRedirect.map == "function") {
                names = schemeSettings.globals.loginLookupRedirect
            } else {
                names = schemeSettings.globals.loginLookupRedirect.toString().split(",")
            }

            for (let name of names) {
                if (data[name]) {
                    redirectUrl = data[name]
                    break
                }
            }
        }

        return redirectUrl
    }
    modObj.getLookupRedirectUrl._depends = {
        symbol : __symbolPrefix + "getLookupRedirectUrl",
        modules : [
            "3r/schemeSettings/webapp"
        ]
    }

    if (typeof window == "object" && window.ioc) {
        window.ioc.injectAll(modObj)
    }

    return modObj
})(typeof exports == "object" ? exports : {})
/* This comment tricks JSPM into wrapping the file as CommonJs module.
exports.fake
*/
